import PLAYER from 'types/player';
import API from 'types/api';
import appActions from 'actions/app';
import _ from 'lodash';

import { isUserLoggedInSelector } from 'selectors/user';
import { clearPosition, saveLastWatched, savePosition } from 'utils/serialObjectProgress';
import { parseGetParams } from 'utils/routerUrl';

const savingPeriod = 20;
let lastPosition = 0;

export default (store) => (next) => (action) => {
  // в рамка EMB-1007 была „потеряна“ передача 'property:position' в redux
  if (
    action.type === PLAYER.HANDLE_CHANGE_PROPERTY &&
    action.payload.name === 'property:position'
  ) {
    const position = action.payload.data;
    if (Math.abs(position - lastPosition) >= savingPeriod) {
      lastPosition = position;
      processPosition(store, position);
    }
  } else if (action.type === PLAYER.HANDLE_STOP) {
    const state = store.getState();
    processPosition(store, state.player.property.position, action.type);
  } else if (action.type === API.GET_STREAM_SUCCESS) {
    const isLoggedIn = isUserLoggedInSelector(store.getState());
    lastPosition = 0;

    if (!isLoggedIn) {
      checkAndSaveLastSerialObject(window.location.search, action.payload || {});
    }

    if (action.payload.live_start && action.payload.content_type.indexOf('live') !== -1) {
      action.payload.content_type = 'live_dvr';
    }
  } else if (action.type === PLAYER.ERROR) {
    if (!('data' in action.payload)) {
      action.payload = { data: action.payload };
      // player can send event without 'data' field, so wrap payload in such object
    }
  }
  return next(action);
};

const checkAndSaveLastSerialObject = (search, stream) => {
  const { id } = parseGetParams(search);
  if (stream.video_id && stream.content_type !== 'trailer' && (stream.next || stream.prev)) {
    saveLastWatched(id, stream.video_id);
  }
};

const processPosition = (store, position, type) => {
  const state = store.getState();
  if (_.get(state, 'player.stream.content_type', 'trailer') === 'trailer') {
    return;
  }
  if (state.player.property.started) {
    const isLogin = isUserLoggedInSelector(state);
    const duration = state.player.property.duration;
    const movieId = state.player.stream.video_id;
    const objectId = state.app.id;
    if (!isLogin) {
      const percent = Math.round(position / duration * 1000) / 1000;
      if (percent < 0.95) {
        savePosition(movieId, percent, Math.round(position));
      } else {
        clearPosition(movieId);
      }
    } else if (type === PLAYER.HANDLE_STOP) {
      const percent = Math.round(position / duration * 100);
      store.dispatch(appActions.saveMoviePosition(objectId, movieId, position, percent));
    }
  }
};
